import styled from 'styled-components';

type NotificationBadgeProps = {
  numberOfItems: number;
  position: 'bottom' | 'top';
  color: 'blue' | 'red';
};

type BadgeProps = {
  color: 'blue' | 'red';
};

const NotificationBadge = ({
  numberOfItems,
  position,
  color,
}: NotificationBadgeProps) => {
  return position === 'top' ? (
    <TopPositionedBadge color={color}>{numberOfItems}</TopPositionedBadge>
  ) : (
    <BottomPositionedBadge color={color}>{numberOfItems}</BottomPositionedBadge>
  );
};

export default NotificationBadge;

const Badge = styled.span<BadgeProps>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  background-color: ${({ color }) => (color === 'red' ? '#ff1f1f' : '#1e38ae')};
  border-bottom: 0.0625rem solid
    ${({ color }) => (color === 'red' ? '#ff9999' : '#627ae4')};
  padding: 0.125rem 0.25rem;
  border-radius: 0.5625rem;
  min-width: 1.1rem;
  box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.3);
  user-select: none;
`;

const TopPositionedBadge = styled(Badge)`
  right: -0.5rem;
  top: -0.2rem;
`;

const BottomPositionedBadge = styled(Badge)`
  right: -0.5rem;
  bottom: -0.2rem;
`;
